<template>
    <div>
      <header>
        配电箱名称：
        <el-input
          v-model="powerBoxName"
          placeholder="请输入配电箱名称"
          style="width: 200px;margin-right: 10px;"
        ></el-input>控制器编号：
        <el-input
          v-model="powerBoxNumber"
          placeholder="请输入控制器编号"
          style="width: 200px;margin-right: 10px;"
        ></el-input>
        温度传感器编号：
        <el-input
          v-model="temperatureSensorNumber"
          placeholder="请输入温度传感器编号"
          style="width: 200px;margin-right: 10px;"
        ></el-input>
        物联网卡SSID：
        <el-input
          v-model="netWorkSSID"
          placeholder="请输入物联网卡SSID"
          style="width: 200px;margin-right: 10px;"
        ></el-input>状态：
        <el-select
          v-model="status"
          placeholder="请选择"
        >
          <el-option
            label="全部"
            value=""
          ></el-option>
          <el-option
            label="未绑定"
            value="0"
          ></el-option>
          <el-option
            label="已绑定"
            value="1"
          ></el-option> </el-select>
        <el-button
          type="primary"
          icon="el-icon-search"
          style="margin-left: 10px"
          @click="getList()"
        >查询</el-button>
      </header>
      <el-table
        :data="tableData"
        border
        style="width: 100%; margin-top: 20px"
      >
        <el-table-column
          prop="powerBoxName"
          label="配电箱名称"
          width="180"
        ></el-table-column>
        <el-table-column
          prop="qrCode"
          label="二维码编号"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="powerBoxNumber"
          label="控制器编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="blueToothName"
          label="控制器蓝牙名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="temperatureSensorNumber"
          label="温度传感器编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="netWorkSSID"
          label="物联网卡SSID"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column
        prop="statusStr"
          label="状态"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
        ></el-table-column>
      </el-table>
      <div
        class="tc"
        style="margin-top: 20px"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>

    </div>
  </template>
  
  <script>
  // TODO companyID没改，需要确认
  import { Api_SuperAdmin } from "@/api/api";
  import { getStore } from "@/util/store";
  export default {
    components: {
    },
    data() {
      return {
        totalCount: 0,
        currentPage: 1,
        pagesize: 10,
        searchKey: "",
        status: "",
        powerBoxName:"",
        powerBoxNumber:"",
        temperatureSensorNumber:"",
        netWorkSSID:"",
        tableData: [],
        companyId: "",
        projectId: getStore({ name: "projectId" }),
      };
    },
    created() {
      this.getList();
    },
    methods: {
      getList() {
        Api_SuperAdmin.getList({
          pageSize: this.pagesize,
          pageIndex: this.currentPage,
          powerBoxName: this.powerBoxName,
          powerBoxNumber: this.powerBoxNumber,
          temperatureSensorNumber: this.temperatureSensorNumber,
          netWorkSSID: this.netWorkSSID,
          status: this.status,
        }).then((res) => {
          this.tableData = res.data.data.items;
          this.totalCount = res.data.data.totalCount;
        });
      },
      handleSizeChange(size) {
        this.pagesize = size;
        this.getList();
      },
      handleCurrentChange(currentPage) {
        this.currentPage = currentPage;
        this.getList();
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .pushInformation {
    width: 100px;
    height: 30px;
    padding: 0 10px;
    background-color: #169bd5;
    cursor: pointer;
    border: none;
    border-radius: 3px;
    color: #fff;
    /deep/ .el-tooltip__popper {
      width: 200px;
    }
  }
  </style>
  <style>
  .groupLists .el-checkbox {
    width: 20%;
    margin-right: 4%;
  }
  </style>